import React from 'react';
import HeaderOne from '../Components/Header/HeaderOne';
import Gifting from '../Components/Gifting/Gifting'; // renamed import
import Footer from '../Components/Footer/FooterOne';
import { Helmet } from "react-helmet-async";   // ✅ correct import

function GiftingPage() { // renamed component
    return (
        <>

        <Helmet>
                <title>Homemade Festive Sweets & Gift Hampers in Coimbatore | Tickling Tummy</title>
                <meta name="description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, creating premium gift hampers in R.S. Puram for Diwali and special occasions." />
                <meta name="keywords" content="Festive gift hampers Coimbatore, Homemade sweets Coimbatore, Savory snacks gift box, Diwali sweets Coimbatore, Vegetarian festive gifts" />
                <link rel="canonical" href="https://ticklingtummy.com/gifting" />
                
                {/* Open Graph Tags */}
                <meta property="og:title" content="Homemade Festive Sweets & Gift Hampers in Coimbatore | Tickling Tummy" />
                <meta property="og:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, creating premium gift hampers in R.S. Puram for Diwali and special occasions." />
                <meta property="og:image" content="https://ticklingtummy.com/assets/images/festive-food-gifting-hampers-coimbatore.jpg" />
                <meta property="og:url" content="https://ticklingtummy.com/gifting" />
                <meta property="og:type" content="website" />
                
                {/* Twitter Card Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Homemade Festive Sweets & Gift Hampers in Coimbatore | Tickling Tummy" />
                <meta name="twitter:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, creating premium gift hampers in R.S. Puram for Diwali and special occasions." />
                <meta name="twitter:image" content="https://ticklingtummy.com/assets/images/festive-food-gifting-hampers-coimbatore.jpg" />
            </Helmet>

        <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
  {
    "@type": "ListItem",
    "position": 1,
    "name": "Home",
    "item": "https://ticklingtummy.com"
  },
  {
    "@type": "ListItem",
    "position": 2,
    "name": "Festive Gifting",
    "item": "https://ticklingtummy.com/gifting"
  }
]
        }, null, 2)}
        </script>

            <HeaderOne />
            <Gifting />
            <Footer />
        </>
    );
}

export default GiftingPage;
